export const sliderPhotos = [
  {
    id: 1,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669795685/kosmedik/karelys-ruiz-PqyzuzFiQfY-unsplash_ituvhw.jpg",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669795676/kosmedik/raphael-lovaski-Pe9IXUuC6QU-unsplash_uwybng.jpg",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669795673/kosmedik/engin-akyurt-g-m8EDc4X6Q-unsplash_kvqbnl.jpg",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669795673/kosmedik/huha-inc-OfVESgqrbJc-unsplash_wfcrlx.jpg",
  },
  {
    id: 5,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796268/kosmedik/dermedics_LIFT_kompo_02_dzmcpb.png",
  },
  {
    id: 6,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796267/kosmedik/dermedics_WHITE_kompo_02_dfqvpx.png",
  },
  {
    id: 7,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796266/kosmedik/dermedics_SLIM_kompo_06_huhxi2.png",
  },
  {
    id: 8,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796265/kosmedik/dermedics_PEEL_kompo_02_bgca6h.png",
  },
  {
    id: 9,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796264/kosmedik/dermedics_CALM_kompo_03_gazv6n.png",
  },
  {
    id: 10,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796264/kosmedik/dermedics_HYDRA_kompo_03_m1vqez.png",
  },
  {
    id: 11,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796264/kosmedik/dermedics_GENX_kompo_03_tbpyw7.png",
  },
  {
    id: 12,
    img: "https://res.cloudinary.com/lvimeridijan/image/upload/v1669796263/kosmedik/dermedics_ECM_kompo_02_aoz6jb.png",
  },
];
